import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getNonInventoryItems } from '@store/INV/MasterItems/MasterItemsSlice';
import { useTranslation } from 'react-i18next';

const useGetNonInventoryItems = () => {
  const dispatch = useAppDispatch();

  const { i18n } = useTranslation();

  useEffect(() => {
    dispatch(getNonInventoryItems());
  }, [dispatch]);

  const {
    NonInventoryItemsList,
    NonInventoryItemsLoading: loading,
    NonInventoryItemsError: error
  } = useAppSelector(state => state.MasterItemsINV);

  // console.log(NonInventoryItemsList);

  const NonInventoryItemsOptions = NonInventoryItemsList?.map(item => ({
    value: item.itemId,
    label: i18n.language === 'en' ? item.name : item.name2,
    //________________________________________________________________
    itemId: item.itemId,
    itemType: item.itemType,
    uom: item.unitOfMeasure,
    uomName: i18n.language === 'en' ? item.unitOfMeasureName : item.unitOfMeasureName2
  }));

  return { NonInventoryItemsOptions, NonInventoryItemsList, loading, error };
};

export default useGetNonInventoryItems;
